// DS: i1.10
import React from 'react';
import IconWrap from '../../IconWrap';
const Tier = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "32",
        height: "32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M27.6407 11.3805L25.1592 23.9248C25.0665 24.3932 24.6556 24.7308 24.1782 24.7308H7.82128C7.34381 24.7308 6.93295 24.3932 6.84029 23.9248L4.3587 11.3805C4.20444 10.6008 4.97768 9.9614 5.71459 10.2594L11.4997 12.5989L15.1034 5.31242C15.4704 4.57017 16.529 4.57018 16.8961 5.31243L20.4997 12.5989L26.2849 10.2594C27.0218 9.9614 27.795 10.6008 27.6407 11.3805Z"
    })));
Tier.displayName = 'Tier';
export default Tier;
